<template>
  <div class="errata">
    <div class="errata-query">
      {{ select.active }}
      <el-select
        v-model="select.active"
        placeholder="请选择"
        size="small"
        @change="handleChange"
      >
        <el-option
          v-for="item in select.option"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      &nbsp;
      <el-button size="small" type="primary" @click="hanldeExport"
        >导出</el-button
      >
      <el-button size="small" type="primary" plain @click="set.visible = true"
        >设置</el-button
      >
    </div>
    <div class="errata-content">
      <ul class="totals">
        <li>
          <span class="color" />
          <span>错词{{ total.err }}处</span>
        </li>
        <li>
          <span class="color yellow" />
          <span>疑问词{{ total.doubt }}处</span>
        </li>
        <li>
          <span class="color violet" />
          <span>敏感词{{ total.sensitive }}处</span>
        </li>
      </ul>
      <base-table
        :tableTitle="tableTitle"
        :tableData="tableData"
        @handleRow="handleRow"
      >
        <template v-slot:confidence="{ rowDate }">
          {{ confidenceName(rowDate) }}
        </template>
        <template v-slot:error_word="{ rowDate }">
          {{ content(rowDate) }}
        </template>
      </base-table>
    </div>
    <!-- 弹框 -->
    <v-setting :visible.sync="set.visible" />
  </div>
</template>

<script>
import BaseTable from "@/components/BaseTable/index";
import BaseDialog from "@/components/BaseDialog/index";
import { addTextSelectionColor, arrayReduce } from "../../utils/common.js";
import dlgFunc from "../textProofreading/index.js";
import VSetting from "./dialog/setting.vue";

export default {
  name: "errata",
  components: {
    BaseDialog,
    BaseTable,
    VSetting,
  },
  data() {
    return {
      select: {
        active: "全部",
        option: [
          {
            value: "全部",
            label: "全部",
          },
          {
            value: "错词",
            label: "错词",
          },
          {
            value: "疑问词",
            label: "疑问词",
          },
          {
            value: "敏感词",
            label: "敏感词",
          },
        ],
      },
      tableTitle: [
        {
          label: "类型",
          prop: "confidence",
        },
        {
          label: "错误内容",
          prop: "error_word",
        },
        {
          label: "修改建议",
          prop: "right_word",
        },
      ],
      tableData: [],
      dataTotal: [],
      set: {
        visible: false,
      },
      data: [],
      exportList: [],
    };
  },
  computed: {
    total() {
      const totals = this.data.reduce(
        (prev, curr) => {
          const { errorTypeName } = curr;
          if (errorTypeName === "敏感词") {
            prev.sensitive = prev.sensitive + 1;
          } else if (errorTypeName === "疑问词") {
            prev.doubt = prev.doubt + 1;
          } else if (errorTypeName === "错词") {
            prev.err = prev.err + 1;
          }
          return prev;
        },
        {
          err: 0,
          doubt: 0,
          sensitive: 0,
        }
      );
      return totals;
    },
    confidenceName() {
      return (item) => {
        const { confidence, type } = item;
        if (type.indexOf("敏感词") >= 0) {
          return "敏感词";
        }
        if (confidence > 0.85) {
          return "错词";
        } else if (confidence <= 0.85 && confidence > 0.6) {
          return "疑问词";
        }
        return confidence;
      };
    },
    content() {
      return (row) => {
        return `${row.error_word}(${row.appearTotal}处)`;
      };
    },
  },
  mounted() {
    this.$nextTick(() => {
      const data = JSON.parse(localStorage.getItem("errorStatistics"));
      if (data.list.length > 0) {
        this.data = data.list;
        this.dataTotal = arrayReduce(data.list, "error_word");
        this.handleChange(this.select.active);
      }
    });
  },
  methods: {
    hanldeExport() {
      this.get();
    },
    get() {
      let l_ksoFileDialog = wps.WpsApplication().FileDialog(2);
      let name = dlgFunc.CWps.Application.ActiveDocument.Name.split(".");
      l_ksoFileDialog.InitialFileName = name[0] + "_纠错报告"; //文档名称

      // 打开新窗口
      dlgFunc.CWps.Application.Documents.Add();
      window.close();

      this.add();
      if (l_ksoFileDialog.Show() == -1) { // -1 代表确认按钮

        l_ksoFileDialog.Execute(); //会触发保存文档的监听函数
        // dlgFunc.CWps.Application.ActiveDocument.SaveAs2();
        wps.ribbonUI.Invalidate(); //刷新Ribbon的状态
      }
    },
    handleChange(val) {
      const list = [];
      this.dataTotal.forEach((i) => {
        if (val === "全部") {
          list.push(i);
        } else {
          if (i.errorTypeName === val) {
            list.push(i);
          }
        }
      });
      this.tableData = list;
    },
    // 点击表格某一行
    handleRow(row) {
      wps.PluginStorage.setItem("isUpdateDialog", false);
      const { start, end } = row;
      dlgFunc.CWps.Application.Selection.SetRange(start, end);
      dlgFunc.CWps.Application.ActiveDocument.ActiveWindow.Selection.Range.Select();
      dlgFunc.openDialog("updateAdvice?item=" + JSON.stringify(row), '修改建议',  220, 320);
    },
    // 生成错误内容
    add() {
      const { errorStatistics } = localStorage;
      const { list } = JSON.parse(errorStatistics);
      let doc = dlgFunc.CWps.WpsApplication().ActiveDocument;
      let name = dlgFunc.CWps.Application.ActiveDocument.Name.split(".");
      const checkList = localStorage.getItem("checkList");
      const checks = checkList ? JSON.parse(checkList) : [];

      if (doc) {
        doc.Paragraphs.Add(); //设置为段落1
        doc.Paragraphs.Item(1).IndentCharWidth(10); //缩进
        doc.Paragraphs.Item(1).Style = "标题 1";
        //设置标题
        doc.Range(0, 0).Text = name[0] + "_纠错报告";
        const title1 = checks.includes("错词") ? `错词${this.total.err}处` : "";
        const title2 = checks.includes("疑问词")
          ? `疑问词${this.total.doubt}处`
          : "";
        const title3 = checks.includes("敏感词")
          ? `敏感词${this.total.sensitive}处`
          : "";
        //设置内容
        let rngRange1 = doc.Range(
          doc.Paragraphs.Item(1).Start,
          doc.Paragraphs.Item(1).End - 1
        );
        doc.Paragraphs.Add(); //设置为段落2
        rngRange1.InsertAfter(`纠错结果：${title1} ${title2} ${title3}`);
        doc.Paragraphs.Add();
        list.forEach((i, index) => {
          const {
            errorTypeName,
            error_word,
            right_word,
            type,
            pageNo,
            rowNumber,
            text,
            offset,
          } = i;
          doc.Paragraphs.Add();//设置为段落3：错误位置
          let rngRange2 = doc.Range(doc.Paragraphs.Item(2).Start, doc.Paragraphs.Item(2).End - 1);
          rngRange2.InsertAfter(index + 1 + '. 第' + pageNo + '页第' + rowNumber + '行');

          doc.Paragraphs.Add();//设置为段落4：错词、正词
          let rngRange3 = doc.Range(doc.Paragraphs.Item(3).Start, doc.Paragraphs.Item(3).End - 1);
          rngRange3.InsertAfter(`${errorTypeName}:${error_word}   正词:${right_word}`);

          doc.Paragraphs.Add();//设置为段落5:错误原因
          let rngRange4 = doc.Range(doc.Paragraphs.Item(4).Start, doc.Paragraphs.Item(4).End - 1);
          rngRange4.InsertAfter(`错误原因：${type}`);

          doc.Paragraphs.Add();//设置为段落6:原句
          let rngRange5 = doc.Range(doc.Paragraphs.Item(5).Start, doc.Paragraphs.Item(5).End - 1);
          const text_ = text.replace(/\r|\n/g,"");
          rngRange5.InsertAfter(`原句：${text_}`);

          const index2 = index + 1;
          if(index2 <= 1) {
            doc.Paragraphs.Item(6).Range.Font.ColorIndex = 6;
            // 设置目录
            doc.Paragraphs.Item(5).Style='标题 5';
            doc.Paragraphs.Item(5).Style.Font.Bold = false;
            doc.Paragraphs.Item(5).Style.Font.Size = 12;
            doc.Paragraphs.Item(5).Style.ParagraphFormat.LineSpacingRule = 0;
            doc.Paragraphs.Item(5).Style.ParagraphFormat.SpaceAfter = 0;
            doc.Paragraphs.Item(5).Style.ParagraphFormat.SpaceBefore = 0;
            const originalSentence = doc.Paragraphs.Item(8).Range;
            addTextSelectionColor({
              ...i,
              start: originalSentence.Start + offset + 3,
              end: originalSentence.Start + offset + error_word.length + 3,
            });
          } else {
            const num = Math.floor((index2 * 4) + 2)
            doc.Paragraphs.Item(num).Range.Font.ColorIndex = 6;
            // 设置目录
            const num2 = Math.floor(index2 * 4 + 1)
            doc.Paragraphs.Item(num2).Style='标题 5';
            doc.Paragraphs.Item(num2).Style.Font.Bold = false;
            doc.Paragraphs.Item(num2).Style.Font.Size = 12;

            const num3 = Math.floor(index2 * 4 + 4);
            const originalSentence = doc.Paragraphs.Item(num3).Range;
            // 原句标记
            addTextSelectionColor({
              ...i,
              start: originalSentence.Start + offset + 3,
              end: originalSentence.Start + offset + error_word.length + 3,
            });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.errata {
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
}

.totals {
  display: flex;
  padding: 0;
  justify-content: space-evenly;
}

li {
  list-style: none;
  font-size: 15px;
  vertical-align: middle;
}

.color {
  width: 12px;
  height: 12px;
  margin-right: 5px;
  display: inline-block;
  background-color: red;
  border-radius: 20px;
}

.yellow {
  background-color: Yellow;
}

.violet {
  background-color: Violet;
}
</style>
